import Vue from 'vue'
import '@/mixins/logging'
import '@/plugins/coreui-vue'
import {
    cilEnvelopeOpen, cilLockLocked, cilBullhorn, cilUser, cilX, cilShare,
    cilDataTransferDown, cilMenu, cilRowing, cilGauge, cilVideo, cilPencil, cilHome, cilInfo, cilSchool, cilUserFollow, cilRoom, cilLink,
    cilExternalLink, cilThumbUp, cilThumbDown, cilVolumeOff, cilVolumeHigh, cilBasket, cilMagnifyingGlass, cilLockUnlocked
} from '@coreui/icons'
import '@/plugins/vue-select'
import App from '@/App.vue'
import router from '@/plugins/router'
import '@/plugins/linkify'
import '@/plugins/vue-clipboard'
import '@/plugins/awesome-swiper'
import {apolloProvider} from '@/plugins/apollo'
import '@/assets/scss/common.scss'
import '@/plugins/vue2-touch-events'

Vue.config.productionTip = false
Vue.config.devtools = process.env.VUE_APP_DEV_TOOLS === 'true'
new Vue({
    apolloProvider,
    router,
    render: h => h(App),
    icons: {
        cilEnvelopeOpen, cilLockLocked, cilBullhorn, cilUser, cilX, cilShare,
        cilDataTransferDown, cilMenu, cilRowing, cilGauge, cilVideo, cilPencil, cilHome, cilInfo, cilSchool, cilUserFollow, cilRoom, cilLink,
        cilExternalLink, cilThumbUp, cilThumbDown, cilVolumeOff, cilVolumeHigh, cilBasket, cilMagnifyingGlass, cilLockUnlocked
    }
}).$mount('#app')